import React, { useEffect, useState } from "react";
import styles from "./home.module.scss";
import Carousel from "../../components/common/Carousel/Carousel";
import Highlights from "../../components/common/Highlights/Highlights";
import ModalCollapse from "../../components/common/ModalCollapse/ModalCollapse";
import SlideInImage from "../../components/common/Animations/SlideInImage";
import { motion } from "framer-motion";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import { faPhone } from "@fortawesome/free-solid-svg-icons";
import Contact from "../Contact/Contact";

const Home = () => {
  const [showIcon, setShowIcon] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 100) {
        // Adjust the scroll distance as needed
        setShowIcon(true);
      } else {
        setShowIcon(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const carouselImages = [
    {
      src: "./1.jpeg",
      direction: "up-to-down", // Slide from up to down
      align: "left", // Align to the left
    },
    {
      src: "/Slider-image-3.webp",
      direction: "down-to-up", // Slide from down to up
      align: "right", // Align to the right
    },
  ];
  const sampleFlatImages = [
    {
      src: "./flat4.jpeg",
      direction: "up-to-down", // Slide from up to down
      align: "left", // Align to the left
      text: "Relax in your cozy Living room designed for ultimate comfort.",
    },
    {
      src: "./flat3.jpeg",
      direction: "up-to-down", // Slide from down to up
      align: "right", // Align to the right
      text: "Unwind in your serene Bedroom perfect for peaceful rest.",
    },
    {
      src: "./flat5.jpeg",
      direction: "up-to-down", // Slide from up to down
      align: "left", // Align to the left
      text: "Refresh in your elegant Washroom designed for comfort and style.",
    },
    {
      src: "./flat2.jpeg",
      direction: "up-to-down", // Slide from down to up
      align: "right", // Align to the right
      text: "Cook effortlessly in your Modular kitchen where style meets functionality.",
    },
  ];
  const carouselGalleryImages = [
    "./2.jpeg",
    "./3.jpeg",
    "./4.jpeg",
    "./5.jpeg",
    "./6.jpeg",
    "./7.jpeg",
    "./8.jpeg",
    "./9.jpeg",
    "./10.jpeg",
  ];
  const testimonialArray = [
    "Great Project with High class amenities and space , Lush green park. Club House Etc. Project located at prime location of patiala.Construction in full swing",
    "Hat’s off to the industry leading infrastructure. luxurious, affordable, secure you name it and they have it. It’s really remarkable what the whole team has done in a really short span of time. I would highly recommend everyone to have a visit with family and I’m sure you won’t be disappointed.",
    "One of the exclusive luxury project in prime location .The hot selling property with great ambience and the number of amenities loading with royal structure and fully four sided open road attached with class of society representing it's all around religious environment  with rich culture ritualistic its own way radiating positivity Radiance homes.",
    "Love to shift this society ,professionals planed project’s excellent layout spacious flats with balcony give feeling high end luxury flats as well kothi that why I had booked the flat for personal use and to  give comfort and security to my family",
  ];

  const textVariants = {
    hidden: { opacity: 0, x: -100 }, // Start from left
    visible: {
      opacity: 1,
      x: 0,
      transition: { duration: 0.3, ease: "easeOut" },
    },
  };

  // const handleEnquiryScroll = () => {
  //   const enquiryForm = document.querySelector(
  //     `.${styles.callbackFormContainer}`
  //   );
  //   if (enquiryForm) {
  //     enquiryForm.scrollIntoView({ behavior: "smooth" });
  //   }
  // };
  const handleWhatsAppClick = () => {
    window.open("https://wa.me/7717302292", "_blank");
  };
  const handleCallClick = () => {
    window.open("tel:+91 9882898829");
  };

  return (
    <>
      {/* Contact icons */}
      <p style={{margin:'20px',fontStyle:'italic', fontWeight:'bold'}}>*Welcome to the Official Website of Radiance Homes. Please note: Other websites are not authorized to represent us.*</p>

      {showIcon && (
        <div className={styles.whatsappIcon} onClick={handleWhatsAppClick}>
          <FontAwesomeIcon icon={faWhatsapp} />
        </div>
      )}

      {/* Sample Flat */}
      <motion.div
        className={styles.middleContainer}
        initial="hidden"
        animate="visible"
      >
        <motion.h2 className={styles.header} variants={textVariants}>
          The Heritage City Patiala
        </motion.h2>
        <motion.h3 className={styles.subHeader} variants={textVariants}>
          A project by SK Land Pro
          {/* will add logo later */}
          {/* <img src="/SKLandPro.png"height='200px' ></img> */}
        </motion.h3>
        <motion.p className={styles.desc}>
          Introducing you to a life you’ve aspired for, and world-class designs
          you’ve always yearned for. You’ve lived your version of a lavish life;
          now experience the real deal at ‘RADIANCE HOMES’. With an edge over
          the rest, and centrally located in the heart of Patiala, RADIANCE
          HOMES is Patiala’s new luxury landmark in the making.
        </motion.p>
        <motion.p
          className={styles.enquireBtn}
          variants={textVariants}
          onClick={handleCallClick}
        >
          Enquire Now <FontAwesomeIcon icon={faPhone} />
        </motion.p>

        {sampleFlatImages.map((image, index) => (
          <SlideInImage
            key={index}
            src={image.src}
            direction={image.direction}
            align={image.align}
            text={image.text}
            component="sampleFlats"
          />
        ))}
      </motion.div>

      {/* Description  */}

      <motion.div
        className={styles.middleContainer2}
        initial="hidden"
        animate="visible"
      >
        {/* <motion.p className={styles.header} variants={textVariants}>
          The Heritage City Patiala
        </motion.p> */}
        <motion.h3 className={styles.subHeader} variants={textVariants}>
          A New Wave Of Living
        </motion.h3>
        <motion.p className={styles.desc} variants={textVariants}>
          Introducing you to a life you have aspired for, and world-class
          designs you have always yearned for. You've lived your version of a
          lavish life, now experience the real deal...at <b>RADIANCE HOMES</b>
        </motion.p>
        {/* <motion.p
          className={styles.enquireBtn}
          variants={textVariants}
          onClick={handleEnquiryScroll}
        > */}
        <a
          className={styles.enquireBtn}
          href="/FloorPlan"
          // target="_blank"
          // rel="noopener noreferrer"
        >
          View Floor Plan <i className="fas fa-arrow-right"></i>
        </a>
        {/* </motion.p> */}

        {carouselImages.map((image, index) => (
          <SlideInImage
            key={index}
            src={image.src}
            direction={image.direction}
            align={image.align}
          />
        ))}

        <p></p>
        <motion.h3 style={{marginTop:'24px'}} variants={textVariants}>
        Experience a glimpse of your future home
        </motion.h3>
        
        <video
        src="/radianceHomes.mp4"
        // autoPlay
        loop
        style={{ width: "100%", height: "100%" ,margin:'12px 0px'}}
        poster="/radianceThumbnail.png" 
        controls
      ></video>
      </motion.div>

      {/* <div className={styles.middleContainer}>
                <p className={styles.header}>The Heritage City Patiala</p>
                <p className={styles.subHeader}>A New Wave Of Living</p>
                <p className={styles.desc}>Introducing you to a life you’ve aspired for,
                    and world-class designs you’ve always yearned for.
                    You’ve lived your version of a lavish life;
                    now experience the real deal…at ‘RADIANCE HOMES’.
                    With an edge over the rest, and centrally located in the heart of Patiala,
                    RADIANCE HOMES is Patiala’s new luxury landmark in the making.
                </p>
                <p className={styles.desc}>This premium project by AVR Group is adorned with every necessary convenience of city life.
                    Tastefully stylish and luxurious 3&4 BHK apartments, with distinctive specifications,
                    convenient roadways, the proximity to institutions and entertainment hubs,
                    lush green corners, and an exhaustive list of amenities,
                    RADIANCE HOMES is your royalty realised.
                </p>
                <a className={styles.enquireBtn}>Know More </a>
            </div> */}

      {/* Architectural Highlights */}

      <div className={styles.architectureContainer}>
        <h2 className={styles.header}>Architectural Highlights</h2>
        <p className={styles.subHeader}>
          Radiance Homes Patiala is the all new canvas on the real estate
          landscape inspired by the idea of understanding what people want and
          creating aspirational spaces crafted to enhance life.
        </p>
        <Highlights />
      </div>

      {/* Gallery Carousel */}

      <div className={styles.galleryContainer}>
        <h2>Why Choose Us ?</h2>
        <Carousel carouselImages={carouselGalleryImages} />
      </div>

      {/* FAQs */}

      <div className={styles.questionContainer}>
        <h2>Frequently Asked Questions</h2>
        <div>
          <ModalCollapse />
        </div>
      </div>

      {/* Testimonials */}

      <div className={styles.testimonialContainer}>
        <h2>Testimonials</h2>
        <Carousel carouselImages={testimonialArray} category="testimonial" />
      </div>
      <div className={styles.contactUs}>
        <Contact/>
      </div>
    </>
  );
};

export default Home;
